import {Component, EventEmitter, Input, OnChanges, OnInit, Output, signal, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-sales-additional-information-field-dropdown',
  templateUrl: './sales-additional-information-field-dropdown.component.html',
  styles: [
  ]
})
export class SalesAdditionalInformationFieldDropdownComponent implements  OnInit, OnChanges {
  @Input( {required: true} ) form!: FormGroup;
  @Input(  {required: true}) field: any;
  @Input(  {required: true} ) groupedField: any;
  @Input() filter: any;
  @Input() variant: 'v2' | 'v3' = 'v2';
  @Output() saveEvent = new EventEmitter();
  isSubmitted = signal(false);

  ngOnInit() {
    this.form.addControl(`${this.field.key}`, new FormControl(this.field.value, [Validators.required]));
  }

  ngOnChanges(changes: SimpleChanges) {
    this.filter = changes['filter']?.currentValue;
    this.onFilter();
    this.save()
  }

  onFilter() {
    if(this.filter !== undefined) {
      this.field.filteredOptions = this.field.options.filter((row: any) => row.parent_id == this.filter.id)
    }else{
      this.field.filteredOptions = this.field.options;
    }
  }

  save() {
    if(this.form.get(this.field.key)?.errors === null) {
      this.saveEvent.emit({id: this.field.id, value: this.form.get(this.field.key)?.value});
    }
  }

  get f() {
    return this.form.controls;
  }
}
